import classNames from "classnames/bind";
import { Check, WarningCircle } from "@phosphor-icons/react";
import React from "react";
import FontAwesome from "react-fontawesome";
import styles from "./FormIcon.module.scss";
import type { FormIconProps } from "./types";

const cx = classNames.bind(styles);

// TODO: consolidate into a new `IconWithTooltip` component or `InputIconWithTooltip` component
const FormIcon = ({
  isValid,
  error,
  isDisabled,
  name,
  className,
  ValidatedIcon = Check,
  ErrorIcon = WarningCircle,
  onClick,
  title = "This is a valid input",
  isAbsolutelyPositionedToRight = false,
}: FormIconProps) => {
  if (isValid) {
    return onClick ? (
      <button
        className={cx(
          "icon",
          "icon--button",
          {
            "icon--disabled": isDisabled,
            "icon--absolute-right": isAbsolutelyPositionedToRight,
          },
          className
        )}
        title={title}
      >
        <ValidatedIcon
          size="25"
          onClick={onClick}
        />
      </button>
    ) : (
      <div
        className={`${cx("icon", {
          "icon--disabled": isDisabled,
          "icon--absolute-right": isAbsolutelyPositionedToRight,
        })} ${className}`}
        role="presentation"
        title={title}
      >
        <ValidatedIcon
          size="25"
          onClick={onClick}
        />
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={cx(
          "icon",
          "icon--error",
          {
            "icon--absolute-right": isAbsolutelyPositionedToRight,
          },
          className
        )}
      >
        <ErrorIcon size="25" />
      </div>
    );
  }

  // IMPROVE: remove font-awesome dependency. this is here atm purely to support legacy app features.
  return name ? (
    <div
      className={cx(
        "icon",
        {
          "icon--absolute-right": isAbsolutelyPositionedToRight,
        },
        className
      )}
    >
      <FontAwesome name={name} />
    </div>
  ) : null;
};

export default FormIcon;
